<template>
  <div>
    <div class="uc-userCenterTitle">
      <div class="left">
        <b>师徒沟通</b>
        <div class="tips">
          <span
            ><i class="uc-blue">{{ list.total_count }}</i
            >次沟通</span
          >
        </div>
      </div>
      <div class="search" style="width:300px;">
        <el-input
          v-model="query.keyword"
          placeholder="请输入搜索关键字"
          style="width:180px;"
          suffix-icon="el-icon-search"
          @change="
            query.pageIndex = 1;
            initData();
          "
        >
        </el-input>
        <el-button
          icon="el-icon-plus"
          @click="
            dialogFromVisible = true;
            initRelationData();
          "
          >添加沟通</el-button
        >
      </div>
    </div>

    <section class="uc-examList">
      <div class="content-empty" v-if="list.total_count == 0">
        <div class="emptyimg-box"></div>
        <p>暂无相关内容</p>
      </div>
      <div v-for="(item, index) in list.items" :key="index" class="item">
        <div class="title">
          <div class="c el-icon-chat-dot-round">
            {{ item.title }}
          </div>
          <router-link
            to=""
            @click.native="
              dialogFromVisible = true;
              initRelationData();
              getCommunicationDetails(item.id);
            "
          >
            <i class="el-icon-edit"></i>
          </router-link>
        </div>

        <div class="con">
          <div class="sub-item w50">
            <i class="el-icon-s-custom"></i> 师傅：{{ item.master_name }}
          </div>
          <div class="sub-item w50">
            <i class="el-icon-time"></i> 沟通日期：{{ item.date.substr(0, 10) }}
          </div>
          <div class="sub-item w100">
            <i class="el-icon-place"></i> 沟通地点：{{ item.address }}
          </div>
          <div
            v-bind:class="{ expansion: item.is_long_content }"
            class="sub-item w100"
            v-html="`<i class=el-icon-document></i> 沟通内容：${item.content}`"
          ></div>
          <el-button
            type="text"
            v-if="item.is_show_btn"
            v-on:click="item.is_long_content = !item.is_long_content"
          >
            <span
              v-html="
                item.is_long_content
                  ? '展开<i class=el-icon-arrow-down></i>'
                  : '收起<i class=el-icon-arrow-up></i>'
              "
            >
            </span>
          </el-button>
        </div>
      </div>
    </section>

    <el-pagination
      class="uc-prvNxt"
      background
      layout="prev, pager, next"
      hide-on-single-page
      :current-page="query.pageIndex"
      :page-size="query.pageSize"
      :total="list.total_count"
      @current-change="handleCurrentChange"
    >
    </el-pagination>

    <el-dialog
      title="沟通记录"
      :visible.sync="dialogFromVisible"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      @close="handleCloseDialog"
    >
      <el-form :model="form" ref="form" :rules="rules">
        <el-form-item
          label="ID"
          prop="id"
          :label-width="formLabelWidth"
          style="display:none;"
        >
          <el-input v-model="form.id"></el-input>
        </el-form-item>
        <el-form-item label="日期" prop="date" :label-width="formLabelWidth">
          <el-date-picker
            v-model="form.date"
            type="datetime"
            placeholder="选择日期"
            format="yyyy-MM-dd HH:mm"
            value-format="yyyy-MM-dd HH:mm"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item
          label="沟通对象"
          prop="master_id"
          :label-width="formLabelWidth"
        >
          <el-select
            style="width:100%;"
            v-model="form.master_id"
            placeholder="请选择师傅"
          >
            <el-option
              v-for="(item, index) in relationList"
              :key="index"
              :label="item.master_name"
              :value="item.master_id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="地点" prop="address" :label-width="formLabelWidth">
          <el-input v-model.trim="form.address" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="标题" prop="title" :label-width="formLabelWidth">
          <el-input v-model.trim="form.title" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="内容" prop="content" :label-width="formLabelWidth">
          <el-input
            type="textarea"
            v-model.trim="form.content"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="handleCancle">取 消</el-button>
        <el-button type="primary" @click.native="handleSubmitSure"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'ApprenticeCommunication',
  data() {
    return {
      query: {
        type: 0,
        apprenticeId: undefined,
        pageIndex: 1,
        pageSize: 10,
        keyword: undefined,
      },
      queryRelation: {
        type: 0,
        relationStatus: undefined,
      },
      list: [],
      relationList: [],
      dialogFromVisible: false,
      pickerOptions: {
        disabledDate: (time) => {
          const now = Date.now();
          return time.getTime() > now;
        },
      },
      form: {
        id: 0,
        master_id: undefined,
        address: '',
        title: '',
        content: '',
        date: '',
      },
      rules: {
        master_id: [{ required: true, message: '请选择师傅', trigger: 'blur' }],
        address: [
          { required: true, message: '请输入沟通地点', trigger: 'blur' },
        ],
        date: [{ required: true, message: '请选择日期', trigger: 'blur' }],
        title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        content: [
          { required: true, message: '请输入沟通内容', trigger: 'blur' },
        ],
      },
      formLabelWidth: '100px',
    };
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      this.getShituCommunications();
    },
    initRelationData() {
      this.getShituRelations();
    },
    async getShituCommunications() {
      const response = await this.$api.shitu.getShituCommunications(this.query);
      this.list = response.data.data;
    },
    async getShituRelations() {
      const response = await this.$api.shitu.getShituRelations(
        this.queryRelation
      );
      this.relationList = response.data.data;
    },
    async getCommunicationDetails(itemId) {
      const response = await this.$api.shitu.getCommunicationDetails({
        id: itemId,
      });
      this.$nextTick(() => {
        this.form = response.data.data;
      });
    },
    // 翻页
    handleCurrentChange(val) {
      this.query.pageIndex = val;
      this.initData();
    },
    // 提交数据
    handleSubmitSure() {
      const submitData = {
        id: this.form.id,
        master_id: this.form.master_id,
        address: this.form.address,
        title: this.form.title,
        content: this.form.content,
        date: this.form.date,
      };
      this.$refs.form.validate((valid) => {
        if (valid) {
          // 请求
          // console.log(submitData);
          this.editShituCommunication(submitData);
        }
      });
    },
    async editShituCommunication(myCommunication) {
      const response = await this.$api.shitu.editShituCommunication(
        myCommunication
      );
      if (response.data.code === 200) {
        this.$message.success(response.data.message);
        this.dialogFromVisible = false;
        this.initData();
        // 清空表单
        this.$nextTick(() => {
          this.$refs.form.resetFields();
        });
      } else {
        this.$message.warning(response.data.message);
      }
    },
    handleCloseDialog() {
      this.$refs.form.resetFields();
    },
    handleCancle() {
      this.dialogFromVisible = false;
      // 点击取消按钮的时候清除输入框中的内容 清除验证
      //  this.$nextTick获取了节点之后进行操作
      this.$nextTick(() => {
        // form对应你写的<el-form ref="form"></el-form>
        this.$refs.form.resetFields();
      });
    },
  },
};
</script>
